
import { computed, defineComponent } from 'vue'
import EventCardArchive from '@/components/block/EventCardArchive.vue'
import Button from '@/components/elements/Button.vue'
import { useEvent } from '@/provider/event'

export default defineComponent({
  name: 'MagazineEventArchive',
  components: {
    EventCardArchive,
    Button
  },

  setup() {
    const { loadArchives, archives: archivesBase } = useEvent()
    loadArchives({
      per_page: 4,
      page: undefined,
      category: undefined,
      tag: undefined,
      type: undefined
    })
    const archives = computed(() => archivesBase.value.slice(0, 4))

    return {
      archives
    }
  }
})
